import { format } from "date-fns";
import { exportRowsToExcel } from "../../../../components/utils/printable-table-generator/exportRowsToExcel";

const formatDate = (value) => {
  if (!value) return "-";

  try {
    return format(new Date(value), "dd-MM-yyyy");
  } catch {
    return "-";
  }
};

export const copyToClipboard = ({ listData, filterValue, uiContext }) => {
  if (!listData || listData.length === 0) {
    uiContext.showErrorMsg("Error", "Tidak ada data yang dapat di-copy");
    return;
  }

  const formatNumber = (value) => `'${Number(value || 0).toLocaleString("id-ID")}`;

  let result = "";

  result += "\t\tLAPORAN PRODUCT CUSTOMER LIST\n";
  result +=
    `Product :\t${filterValue?.data_product?.name ?? "-"}` +
    "\t\t" +
    `Periode :\t${formatDate(filterValue?.start_date)}\tS/D\t${formatDate(filterValue?.end_date)}` +
    "\t\t" +
    `Tanggal Copy\t${formatDate(new Date())}\n`;
  result += "\n";

  result += ["NO", "CUSTOMER CODE", "CUSTOMER NAME", "TOTAL BUY", "TOTAL USE", "TOTAL REMAINING"].join("\t") + "\n";

  let totalBuy = 0;
  let totalUse = 0;
  let totalRemaining = 0;

  listData.forEach((row, index) => {
    const buy = Number(row?.total_buy || 0);
    const use = Number(row?.total_use || 0);
    const remaining = Number(row?.total_remaining || 0);

    totalBuy += buy;
    totalUse += use;
    totalRemaining += remaining;

    result +=
      [
        index + 1,
        row?.customer_code || "-",
        row?.customer_name || "-",
        formatNumber(buy),
        formatNumber(use),
        formatNumber(remaining),
      ].join("\t") + "\n";
  });

  result +=
    ["", "", "TOTAL", formatNumber(totalBuy), formatNumber(totalUse), formatNumber(totalRemaining)].join("\t") + "\n";

  navigator.clipboard
    .writeText(result)
    .then(() => {
      uiContext.showSuccessMsg("Success", "Data berhasil di-copy");
    })
    .catch(() => {
      uiContext.showErrorMsg("Error", "Gagal meng-copy data");
    });
};

export const exportToExcel = ({ listData, filterValue, uiContext }) => {
  if (!listData || listData.length === 0) {
    uiContext.showErrorMsg("Error", "Tidak ada data yang dapat di-export");
    return;
  }

  const rows = [];

  rows.push(["LAPORAN PRODUCT CUSTOMER LIST"]);
  rows.push([
    "Product :", filterValue?.data_product?.name ?? "-",
    "", "Periode :", formatDate(filterValue?.start_date), "S/D", formatDate(filterValue?.end_date),
    "", "Tanggal Copy", formatDate(new Date()),
  ]);
  rows.push([]);

  rows.push(["NO", "CUSTOMER CODE", "CUSTOMER NAME", "TOTAL BUY", "TOTAL USE", "TOTAL REMAINING"]);

  let totalBuy = 0;
  let totalUse = 0;
  let totalRemaining = 0;

  listData.forEach((row, index) => {
    const buy = Number(row?.total_buy || 0);
    const use = Number(row?.total_use || 0);
    const remaining = Number(row?.total_remaining || 0);

    totalBuy += buy;
    totalUse += use;
    totalRemaining += remaining;

    rows.push([
      index + 1,
      row?.customer_code || "-",
      row?.customer_name || "-",
      buy,
      use,
      remaining,
    ]);
  });

  rows.push(["", "", "TOTAL", totalBuy, totalUse, totalRemaining]);

  exportRowsToExcel({
    rows,
    fileName: `Laporan_Product_Customer_List_${format(new Date(), "yyyyMMdd_HHmm")}.xlsx`,
  });
};
